import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=cc96a5d0&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"
import style0 from "./chart.vue?vue&type=style&index=0&id=cc96a5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc96a5d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTab,VTabItem,VTabs,VTabsSlider})
